import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";

const Type = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.averageNumberOfVisitsPerClient.filters.type);
  const selectedFilters = useSelector(
    (state) => state.averageNumberOfVisitsPerClient.selectedFilters.type
  );

  return options.length ? (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      includeFilter={false}
      numberDisplayed={1}
      width={300}
      onSelectChange={(data) => dispatch(actionCreators.updateTypeOption(data))}
    />
  ) : null;
};

export default Type;
